module.exports = __webpack_public_path__ + "static/media/ios-permission-step-2.321f77b6.png";